export default "__VITE_ASSET__BRih90bc__"